import React from "react";
import { NavigatorAction } from "../../../../flux";

const Next = ({ close, nextReading, remaining }) => {
  return (
    <div className="container">
      <div className="message">
        {remaining > 0
          ? `${remaining} more to go!`
          : i18n.t("assignments.assignment-complete")}
      </div>
      <div className="action-button">
        <button className="submit" onClick={nextReading}>
          {i18n.t("assignments.next-reading")}
        </button>
      </div>
      <div className="action-button">
        <button className="noButton" onClick={close}>
          {remaining > 0
            ? i18n.t("assignments.take-break")
            : i18n.t("base.done")}
        </button>
      </div>
    </div>
  );
};

export default Next;
